module.exports = __webpack_public_path__ + "img/Blizzert_ticket_info_KARAOKE_banner_layer.6168a1a7.png";